import { FuseNavigation } from '@fuse/types';
import { PermissionType } from 'app/enums/permission.enum';
import { AppRoutePaths } from 'app/enums/routes.enum';
import {Router} from "@angular/router";

export const navigation: FuseNavigation[] = [
    {
        id: 'home',
        title: 'Home',
        translate: 'NAV.MAIN',
        icon: 'home',
        // url: `../${AppRoutePaths.HOME}`,
        function: (router: Router) => {
            // This is extremelly specific to the routing
            // If the routing changes, this have to change as well
            router.navigate([`./${AppRoutePaths.HOME}`], {relativeTo: router.routerState.root.children[0]})
        },
        type: 'item',
        hidden: false,
    },
    {
        id: 'report-irregularity',
        title: 'report-irregularity',
        translate: 'NAV.REPORT_IRREGULARITY',
        icon: '',
        // url: `./${AppRoutePaths.REPORT_IRREGULARITY}`,
        function: (router: Router) => {
            router.navigate([`./${AppRoutePaths.REPORT_IRREGULARITY}`], {relativeTo: router.routerState.root.children[0]})
        },
        type: 'item',
        hidden: false,
    },
    {
        id: 'make-question',
        title: 'make-question',
        translate: 'NAV.MAKE_QUESTION',
        icon: '',
        // url: `./${AppRoutePaths.MAKE_QUESTION}`,
        function: (router: Router) => {
            router.navigate([`./${AppRoutePaths.MAKE_QUESTION}`], {relativeTo: router.routerState.root.children[0]})
        },
        type: 'item',
        hidden: false,
    },
    {
        id: 'follow-up',
        title: 'follow-up',
        translate: 'NAV.FOLLOW_UP',
        icon: '',
        // url: `./${AppRoutePaths.FOLLOW_UP}`,
        function: (router: Router) => {
            router.navigate([`./${AppRoutePaths.FOLLOW_UP}`], {relativeTo: router.routerState.root.children[0]})
        },
        type: 'item',
        hidden: false,
    },
    {
        id: 'resources',
        title: 'resources',
        translate: 'NAV.RESOURCES',
        icon: '',
        // url: `./${AppRoutePaths.RESOURCES}`,
        function: (router: Router) => {
            router.navigate([`./${AppRoutePaths.RESOURCES}`], {relativeTo: router.routerState.root.children[0]})
        },
        type: 'item',
        hidden: false,
    },
    {
        id: 'frequent-questions',
        title: 'frequent-questions',
        translate: 'NAV.FREQUENT_QUESTIONS',
        icon: '',
        // url: `./${AppRoutePaths.FREQUENT_QUESTIONS}`,
        function: (router: Router) => {
            router.navigate([`./${AppRoutePaths.FREQUENT_QUESTIONS}`], {relativeTo: router.routerState.root.children[0]})
        },
        type: 'item',
        hidden: false,
    },
];

export const tenantSelectorNavigation: FuseNavigation[] = [
    {
        id: 'home',
        title: 'Home',
        translate: 'NAV.MAIN',
        icon: 'home',
        url: AppRoutePaths.SELECT_TENANTS,
        type: 'item',
        hidden: false,
    },
    {
        id: 'resources',
        title: 'resources',
        translate: 'NAV.RESOURCES',
        icon: '',
        url: AppRoutePaths.RESOURCES,
        type: 'item',
        hidden: false,
    },
    {
        id: 'frequent-questions',
        title: 'frequent-questions',
        translate: 'NAV.FREQUENT_QUESTIONS',
        icon: '',
        url: AppRoutePaths.FREQUENT_QUESTIONS,
        type: 'item',
        hidden: false,
    },
];
